import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetUploadReceiptFile } from "redux/actions/uploadReceiptFileAction";
import { showNotificationDialogManualOrder } from "redux/actions/notificationManualOrderAction";
import { postFileAccess, showErrorMessageByCode } from "services/commonServices";
import { SOMS_API_KEY } from "services/CONSTANTS";
import { useDropzoneUpload } from "./useDropzoneUpload";

export const useUploadReceiptFile = () => {
  const [acceptedFiles, setAcceptedFiles] = useState([]);
  const [fileError, setFileError] = useState(null);
  const [showUploadingDialog, setShowUploadingDialog] = useState(false);
  const [resultDialog, setResultDialog] = useState({
    open: false,
    status: null,
    errorFileUrl: null,
    totalRecords: null,
    failedRecords: null,
  });

  const dispatch = useDispatch();
  const { isUploadReceiptFileSuccess, isUploadReceiptFileError, uploadReceiptFileResponse } =
    useSelector((state) => state.uploadReceiptFile);

  useEffect(() => {
    if (isUploadReceiptFileSuccess) {
      setShowUploadingDialog(false);
      setResultDialog({
        open: true,
        status: uploadReceiptFileResponse?.status,
        errorFileUrl: uploadReceiptFileResponse?.errorFileUrl ?? null,
        totalRecords: uploadReceiptFileResponse?.totalRecords ?? null,
        failedRecords: uploadReceiptFileResponse?.failedRecords ?? null,
      });
    }
    if (isUploadReceiptFileError) {
      setShowUploadingDialog(false);
      const { errTitle, errContent } = showErrorMessageByCode(uploadReceiptFileResponse ?? {});
      dispatch(showNotificationDialogManualOrder(errTitle, errContent, "Done"));
      dispatch(resetUploadReceiptFile());
    }
  }, [isUploadReceiptFileSuccess, isUploadReceiptFileError, uploadReceiptFileResponse, dispatch]);

  const handleResultDialogClose = () => {
    setResultDialog({ open: false, status: null, errorFileUrl: null, totalRecords: null, failedRecords: null });
    setAcceptedFiles([]);
    dispatch(resetUploadReceiptFile());
  };

  const downloadTemplate = () => {
    const request = {
      apikey: SOMS_API_KEY,
      params: {
        fileName: "manualPOReceiptTemplate.csv",
        reportType: "template",
      },
    };
    postFileAccess(request)
      .then((response) => {
        const fileDownloadTag = document.createElement("a");
        fileDownloadTag.href = response.fileURL;
        fileDownloadTag.click();
      })
      .catch((err) => {
        const { errTitle, errContent } = showErrorMessageByCode(err);
        dispatch(showNotificationDialogManualOrder(errTitle, errContent, "Done"));
      });
  };

  const { fileRejections, getRootProps, getInputProps, isDragReject, dropzoneStyle, removeFile, handleUploadFile } =
    useDropzoneUpload({ acceptedFiles, setAcceptedFiles, setFileError, setShowUploadingDialog });

  return {
    acceptedFiles,
    fileError,
    showUploadingDialog,
    resultDialog,
    dropzoneStyle,
    isDragReject,
    fileRejections,
    getRootProps,
    getInputProps,
    removeFile,
    handleUploadFile,
    handleResultDialogClose,
    downloadTemplate,
  };
};
